const initialState = { 
  loading: false,
  success: null,
  error: null
}

function saveProducerReducer(state = initialState, action) {
  switch (action.type) {
    case 'SAVE_PRODUCER_BEGIN':
      return {
        ...state,
        loading: true,
        success: null,
        error: null
      }

    case 'SAVE_PRODUCER_SUCCESS':
      return {
        ...state,
        loading: false,
        success: action.success
      }

    case 'SAVE_PRODUCER_FAILURE':
      return {
        ...state,
        loading: false,
        error: action.error
      }

    default: return state
  }
}

export default saveProducerReducer